import { WalletErrorType } from "../../shared/error";
import { base64Image } from "./icon";
export const ctrlChromeExtensionId = "hmeobnfnfcmdkdcmlblgagmfpfboieaf";
const walletInfo = {
    name: "XDEFI",
    icon: base64Image,
    install: {
        chrome: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
    },
    isChainSupported: (chainId) => {
        switch (chainId) {
            case "osmosis-1":
                return true;
            default:
                return false;
        }
    },
    errors: {
        generic: [
            {
                message: "XDEFI: user rejected the message signing",
                type: WalletErrorType.rejected,
            },
            {
                // This is the message XDEFI currently returns
                message: "[object Object]",
                type: WalletErrorType.rejected,
            },
        ],
    },
};
export const xdefiWallet = {
    provider: () => {
        const xdefi = window.xfi?.keplr;
        if (!xdefi) {
            return { installed: false };
        }
        const subscription = (reconnect) => {
            const listener = () => {
                reconnect();
            };
            window.addEventListener("keplr_keystorechange", listener);
            return () => {
                window.removeEventListener("keplr_keystorechange", listener);
            };
        };
        return Object.assign(xdefi, {
            installed: true,
            subscription,
        });
    },
    info: walletInfo,
};
//# sourceMappingURL=index.js.map